module.exports = __webpack_public_path__ + "img/preview-9.bf7a268c.png";